import LoadingSpinner from 'shared/ui/LoadingSpinner'
import StoreInfo from 'shared/ui/StoreInfo'

const StoreSection = ({scanData, refetch, user_idx, isLoading}) => {
	return (
		<>
			{scanData?.eligible_competitions?.map((elem) => (
				<StoreInfo
					data={elem}
					key={elem?.event_idx}
					refetch={refetch}
					user_idx={user_idx}
					isLoading={isLoading}
				/>
			))}
			{isLoading && <LoadingSpinner.Overlay size='large' />}
		</>
	)
}

export default StoreSection
